export default "__VITE_PUBLIC_ASSET__8c7a2d63__"